import { render, staticRenderFns } from "./Malls.vue?vue&type=template&id=d36b022c&scoped=true"
import script from "./Malls.vue?vue&type=script&lang=js"
export * from "./Malls.vue?vue&type=script&lang=js"
import style0 from "./Malls.vue?vue&type=style&index=0&id=d36b022c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36b022c",
  null
  
)

export default component.exports